<template>
  <div
    class="package-detail"
  >
    <div
      class="package-detail__image-wrap"
      @click="handlePackageDetailClick"
    >
      <img
        v-if="offerPackage.ImageListUrl"
        :src="offerPackage.ImageListUrl"
        class="package-detail__image responsive-img"
        alt="You May Also Like"
      >
    </div>
    <div class="package-detail__name">{{ offerPackage.CatalogPackage.RetailName }}</div>
    <div class="package-detail__price">{{ offerPackage.EffectiveCostFormatted }}</div>
    <div class="hidden-xs">
      <package-cta-link
        :link="packageDetailUrl"
        :ga-settings="ctaGoogleAnalyticsSettings"
        text="View &amp; Customize"
        class-modifier="ymal-carousel"
      />
    </div>
  </div>
</template>

<script>
import PackageCtaLink from '@CatalogList/components/PackageCtaLink.vue'
import GoogleAnalytics from '@Shared/lib/google-analytics'

export default {
  name: 'YouMayAlsoLikePackageDetail',
  components: {
    PackageCtaLink
  },
  props: {
    offerPackage: { type: Object, default: null }
  },
  computed: {
    packageDetailUrl () {
      return `${this.$store.state.catalogPageCommon.siteRoot}Catalog/Package/${this.offerPackage.OfferPackageID}?utm_email=${this.$store.state.catalogPageCommon.customerInfo.Email}&LastName=${this.$store.state.catalogPageCommon.customerInfo.LastName}&PIN=${this.$store.state.catalogPageCommon.customerInfo.CustomerRef}`
    },
    ctaGoogleAnalyticsSettings () {
      return {
        category: 'Related Products',
        action: 'click',
        label: `CTA - ${this.offerPackage.CatalogPackage.RetailName}`
      }
    }
  },
  methods: {
    handlePackageDetailClick () {
      GoogleAnalytics.trackEvent(this.ctaGoogleAnalyticsSettings.category, this.ctaGoogleAnalyticsSettings.action, `Image - ${this.offerPackage.CatalogPackage.RetailName}`)
      window.location.href = this.packageDetailUrl
    }
  }
}
</script>

<style lang="scss" scoped>
.package-detail {
  padding: 10px;
  text-align: center;

  &__image {
    cursor: pointer;
    display: block;
    margin: 0 auto 20px auto;
    max-width: 146px;
    max-height: 146px;
    overflow: hidden;
  }

  &__name {
    font-weight: bold;
    font-size: 14px;
    margin-bottom: 10px;
    height: 40px;
  }

  &__price {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 10px;
    font-family: $font-roboto;
  }

  @media screen and (min-width: $screen-sm-min) {
    &__image {
      max-width: 200px;
      max-height: 200px;
    }

    &__name {
      margin-bottom: 20px;
      font-size: 18px;
      height: 60px;
    }

    &__price {
      font-size: 18px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/shared/components/catalog/YouMayAlsoLike/PackageDetail.vue